import axios from 'axios';
import { createScrubbedErrorCapture, errorEnvelope } from '../../../../../utils/sentryUtils';
import { getToken, getTokenHeader } from '../../../../Common/Token';
import { StaffInsuranceBeneficiaryUrl, StaffInsurancesUrl, StaffInsurancesNomineeUrl, AdhaarOCRVerificationUrl, PanOCRVerificationUrl, StaffInsurancesBeneficiaryNomineeUrl } from '../url';

// Scrubbed variant: a raw AxiosError carries err.config with the auth header and
// request body (Aadhaar/PAN images, staff PII), so it must never reach Sentry.
const captureScrubbedError = createScrubbedErrorCapture('beneficiary');

export const getStaffInsuranceAction  = async (company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.get(`${StaffInsurancesUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token));
    return data;
  } catch (err) {
    captureScrubbedError(err, 'getStaffInsuranceAction');
    return errorEnvelope(err);
  }
};

export const AddStaffBeneficiaryAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${StaffInsuranceBeneficiaryUrl()}`,
      data,
      getTokenHeader(token),
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AddStaffBeneficiaryAction');
    return errorEnvelope(err);
  }
};
export const AddStaffNomineeAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${StaffInsurancesNomineeUrl()}`,
      data,
      getTokenHeader(token),
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AddStaffNomineeAction');
    return errorEnvelope(err);
  }
};
export const deleteStaffAction = async (is_beneficiary, is_nominee, staff_no, company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.delete(
      `${StaffInsurancesUrl()}?staff_id=${staff_no}&is_nominee=${is_nominee}&is_beneficiary=${is_beneficiary}&company_esi_id=${company_esi_id}`,
      getTokenHeader(token)
    );
    return data;
  } catch (err) {
    captureScrubbedError(err, 'deleteStaffAction');
    return errorEnvelope(err);
  }
};

export const AdhaarOCRVerficiationAction = async (data, requireAddressMapping = false) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${AdhaarOCRVerificationUrl(requireAddressMapping)}`,
      data,
      { headers: { Authorization: 'Bearer ' + token } },
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AdhaarOCRVerficiationAction');
    return errorEnvelope(err, 'OCR processing failed');
  }
};

export const PanOCRVerificationAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${PanOCRVerificationUrl()}`,
      data,
      { headers: { Authorization: 'Bearer ' + token } },
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'PanOCRVerificationAction');
    return errorEnvelope(err, 'OCR processing failed');
  }
};
export const AddStaffBeneficiaryNomineeAction = async (data) => {
  try {
    const token = await getToken();
    const { data: result } = await axios.post(
      `${StaffInsurancesBeneficiaryNomineeUrl()}`,
      data,
      getTokenHeader(token),
    );
    return result;
  } catch (err) {
    captureScrubbedError(err, 'AddStaffBeneficiaryNomineeAction');
    return errorEnvelope(err);
  }
};
